<template>
  <div class="index" @click="h5show = false">
    <div class="index-con">
      <div class="big-title">
        <span> Co-organizers</span>
      </div>


      <div class="text">
        School of Food Science and Technology, Jiangnan University<br>
        Food Academic Journal Center of Jiangnan University<br>
        Jiangsu Food Science and Technology Society<br>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.imgcenter {
  width: 100%;
  padding: 20px 200px 20px 200px;
}

.text-center {
  text-align: center;
}

.p1 {
  width: 150px;
  display: inline-block;
  margin: 0 auto;
  height: auto;
}

.imgcenter img {
  width: 70%;
}

.top {
  top: 150px;
  left: 0;
  background: #fff;
  height: 70px;
  box-sizing: border-box;
  z-index: 99;
  width: 100%;
  border-top: 10px solid #0a9a7a;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.text {
  color: #333;

  line-height: 2;
  padding-bottom: 20px;
}

.text-blue {
  color: #28d6ec;
  cursor: pointer;
}

.top-bg {
  background-image: url("https://img0.baidu.com/it/u=2363835659,3802656139&fm=253&fmt=auto&app=138&f=JPEG?w=1180&h=492");
  background-size: 100% auto;
  height: 150px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
}

@media screen and (max-width: 768px) {
  .imgcenter {
    padding: 30px 0;
    text-align: center;
  }

  .imgcenter img {
    width: 100%;
  }

  .index-con {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    min-height: 700px;
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/local.vue